//NEW: UI_REVAMP
import { Box, Flex, Text } from '@chakra-ui/react';
import ImgComp from '../../utils/ImgComp';

const FooterInfo = () => {
	return (
		<Flex
			w='full'
			padding='16px 32px'
			justify='space-between'
			h='154px'
			borderRadius={16}
			bg='rgba(251, 239, 245, 0.20)'
			display={{ base: 'none', lg: 'flex' }}
			boxShadow='4px 0 6px 0 rgba(255, 255, 255, 0.25) inset, 4px 2px 3px 0 rgba(255, 255, 255, 0.60) inset, 6px 5px 10px 0 rgba(211, 212, 231, 0.20) inset, -4px -4px 4px 0 rgba(255, 255, 255, 0.25) inset, 4px 4px 10px 0 rgba(153, 152, 172, 0.50)'
		>
			<Flex w='full' px={6} gap={8}>
				<Flex justify='center'>
					<ImgComp svgName='footer' w='auto' h='124px' />
				</Flex>

				<Flex w='full' fontSize='10px' gap={8}>
					<Flex direction='column' flex={1} gap={2}>
						<Text as='h6' fontWeight={600} transform='uppercase'>
							REPUBLIC OF PHILIPPINES
						</Text>
						<Text as='span' color='rgba(89, 89, 89, 1)'>
							All content is in the public domain unless otherwise stated.
						</Text>
					</Flex>

					{/* Column 2 */}
					<Flex direction='column' flex={1} gap={2}>
						<Text as='h6' fontWeight={600} transform='uppercase'>
							ABOUT GOVPH
						</Text>
						<Text as='span' color='rgba(89, 89, 89, 1)'>
							Learn more about the Philippine government, its structure, how government works and
							the people behind it.
						</Text>

						<Flex direction='column'>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								GOV.PH
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Open Data Portal
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Official Gazett
							</Text>
						</Flex>
					</Flex>

					{/* Column 3 */}
					<Flex direction='column' flex={1} gap={2}>
						<Box fontWeight='800'>GOVERNMENT LINKS</Box>
						<Flex direction='column'>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Office of the President
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Office of Vice President
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Senate of Philippines
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								House of Representatives
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Supreme Court
							</Text>
							<Text as='span' color='rgba(89, 89, 89, 1)'>
								Sandiganabyan
							</Text>
						</Flex>
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default FooterInfo;
